import type { citizenshipConfig } from './config';

export type Country = (typeof citizenshipConfig.countryList)[number];

export type GroupedCountries = Record<string, Country[]>;
